export default [
  {
    path: '',
    name: 'event-signup-view',
    component: () => import('@/views/eventSignup/EventSignup.vue'),
    meta: {
      renderNav: true,
      requireAuth: true,
      title: 'Sign Up',
      // Query params listed here will be saved as cookies if the user is redirected to login
      preserveQueryParamsAsCookies: ['rescheduledChallengeUserCode'],
    },
  },
];